<template>
  <v-row
    class="ma-0 login"
    :style="{ 'background-image': 'url(' + require('../assets/bg2.jpg') + ')' }"
  >
    <v-col
      cols="12"
      style="height: 93vh"
      class="d-flex align-center justify-center"
    >
      <div v-if="!($route.name === RESET_PASS)">
        <v-fade-transition leave-absolute hide-on-leave>
          <v-card
            name="login"
            class="mx-auto pa-5"
            max-width="500"
            min-width="300"
            color="rgba(0,0,0,0.15)"
            elevation="0"
            v-on:keyup.enter.stop="doLogin"
            v-if="!forgotPassword"
          >
            <v-card-text>
              <v-form autocomplete="off">
                <v-row>
                  <v-col
                    cols="12"
                    class="d-flex justify-center align-center mb-2"
                  >
                    <h1>{{ $t("pageLogin.titlePage") }}</h1>
                  </v-col>
                  <div
                    class="w-100p d-flex flex-column justify-space-between h-250"
                  >
                    <v-text-field
                      v-model="loginReq.username"
                      :placeholder="$t('pageLogin.username')"
                      outlined
                      required
                      autofocus
                      rounded
                      prepend-inner-icon="mdi mdi-account-circle"
                      :error="msg && Array.isArray(msg['username'])"
                      :error-messages="
                        msg['username'] ? msg['username'][0] : ''
                      "
                      ref="username"
                    />
                    <v-text-field
                      v-model="loginReq.password"
                      :placeholder="$t('pageLogin.password')"
                      :type="showPassword ? 'text' : 'password'"
                      outlined
                      required
                      rounded
                      @hover.prevent
                      prepend-inner-icon="mdi-lock"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                      :error="msg && Array.isArray(msg['password'])"
                      :error-messages="
                        msg['password'] ? msg['password'][0] : ''
                      "
                      ref="iPassword"
                    />
                  </div>
                  <v-btn
                    rounded
                    color="primary"
                    block
                    x-large
                    @click="doLogin"
                    class="mt-3 mb-3"
                  >
                    {{ $t("pageLogin.signIn") }}
                  </v-btn>
                  <!--<p
                    @click="forgotPassword = true"
                    class="forgotPassword indigo&#45;&#45;text darken-4 text-decoration-underline d-inline-block"
                  >
                    {{ $t("pageLogin.forgotPassword") }}
                  </p>-->
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-fade-transition>
        <v-fade-transition leave-absolute hide-on-leave>
          <v-card
            name="forgotPassword"
            class="mx-auto pa-5"
            max-width="500"
            min-width="300"
            height="376"
            color="rgba(0,0,0,0.15)"
            elevation="0"
            v-on:keyup.enter.stop="doLogin"
            v-if="forgotPassword"
          >
            <v-card-text>
              <v-form autocomplete="off">
                <v-row>
                  <v-col
                    cols="12"
                    class="pageTitle d-flex justify-center align-center mb-2"
                  >
                    <v-btn
                      icon
                      @click="forgotPassword = false"
                      class="iconBack"
                    >
                      <v-icon>{{ $t("ic.arrowLeft") }}</v-icon>
                    </v-btn>
                    <h1>{{ $t("pageLogin.forgotPassTitle") }}</h1>
                  </v-col>
                  <div class="w-100p d-flex align-center h-250">
                    <v-text-field
                      v-model="emailReset"
                      :placeholder="$t('pageLogin.email')"
                      outlined
                      required
                      autofocus
                      rounded
                      prepend-inner-icon="mdi-email"
                      :error="msg && Array.isArray(msg['email'])"
                      :error-messages="msg['email'] ? msg['email'][0] : ''"
                      ref="email"
                    />
                  </div>
                  <v-btn
                    rounded
                    color="primary"
                    block
                    x-large
                    @click="sendEmail"
                    class="mt-3"
                  >
                    {{ $t("pageLogin.sendEmail") }}
                  </v-btn>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-fade-transition>
      </div>
      <router-view />
    </v-col>
    <v-col cols="12" class="ma-0 d-flex justify-center">
      <footer>Copyright© Ministop Co., Ltd. All rights reserved.</footer>
    </v-col>
  </v-row>
</template>

<script>
import { SET_AUTH, SET_LOADING } from "@/store/mutations.type";
import { LOGIN } from "@/api/auth";
import { SCREEN } from "@/common/auth.const";
import { SEND_MAIL_RESET_PASSWORD } from "@/api/member";
import { ALERT } from "@/common/utilities";

export default {
  name: "Login",
  data: () => ({
    loginReq: {
      username: "",
      password: "",
    },
    emailReset: "",
    msg: [],
    showPassword: false,
    forgotPassword: false,
    RESET_PASS: SCREEN.RESET_PASS.NAME,
  }),
  methods: {
    async doLogin() {
      this.$store.commit(SET_LOADING, [true, true]);
      try {
        const { data } = await LOGIN(this.loginReq);
        this.setAuth(data);
        if (this.$route.query.redirect) {
          await this.$router.push(this.$route.query.redirect + "");
          return;
        }
        await this.$router.push("/");
      } catch (error) {
        this.msg = error.response.data.validMsgList;
      } finally {
        this.$store.commit(SET_LOADING, [false, true]);
      }
    },
    async sendEmail() {
      try {
        await SEND_MAIL_RESET_PASSWORD({ email: this.emailReset });
        ALERT.SUCCESS(this.$i18n.t("msg.sendMailSuccess"));
      } catch (error) {
        if (error.response.data.validMsgList["email"]) {
          this.msg = error.response.data.validMsgList;
        } else {
          this.msg["email"] = [error.response.data.title];
        }
      }
    },
    setAuth: function (res) {
      this.$store.commit(SET_AUTH, res);
    },
  },
};
</script>

<style lang="scss">
.login {
  background-size: cover;

  .v-input__slot {
    background-color: white !important;

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
    }
  }

  .forgotPassword {
    margin: 16px auto 0 auto;
    cursor: pointer;
  }

  .pageTitle {
    position: relative;
  }

  .iconBack {
    position: absolute;
    left: 0;
  }

  .h-250 {
    height: 172px;
  }
}
</style>
